import {Typography} from "@mui/material";
import {Outlet} from "react-router-dom";


const UserRoute = () => {
    return (
        <Outlet/>
    )
}

export default UserRoute;